// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthActionRouteImport } from './routes/auth-action'
import { Route as CsaeRouteImport } from './routes/csae'
import { Route as ExtensionAuthRouteImport } from './routes/extension-auth'
import { Route as ExtensionSignedInRouteImport } from './routes/extension-signed-in'
import { Route as LinkedinAdRouteImport } from './routes/linkedin-ad'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as RecordingViewRouteImport } from './routes/recording-view'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthAccountRouteImport } from './routes/_auth/account'
import { Route as AuthAiRouteImport } from './routes/_auth/ai'
import { Route as AuthBillingRouteImport } from './routes/_auth/billing'
import { Route as AuthChatRouteImport } from './routes/_auth/chat'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthExploreRouteImport } from './routes/_auth/explore'
import { Route as AuthFeedbackRouteImport } from './routes/_auth/feedback'
import { Route as AuthHelpRouteImport } from './routes/_auth/help'
import { Route as AuthLeadsRouteImport } from './routes/_auth/leads'
import { Route as AuthMembersRouteImport } from './routes/_auth/members'
import { Route as DevAdvancedBlocksPreviewRouteImport } from './routes/dev.advanced-blocks-preview'
import { Route as DevBoardPreviewRouteImport } from './routes/dev.board-preview'
import { Route as DevInteractivePreviewRouteImport } from './routes/dev.interactive-preview'
import { Route as LearnPublicIdRouteImport } from './routes/learn.$publicId'
import { Route as SummarySessionTemplateIdRouteImport } from './routes/summary.$sessionTemplateId'
import { Route as AuthApplicationsSessionIdRouteImport } from './routes/_auth/applications.$sessionId'
import { Route as AuthDevGenerationRouteImport } from './routes/_auth/dev.generation'
import { Route as AuthEvalsIndexRouteImport } from './routes/_auth/evals.index'
import { Route as AuthEvalsLabelRouteImport } from './routes/_auth/evals.label'
import { Route as AuthEvalsLabelingRouteImport } from './routes/_auth/evals.labeling'
import { Route as AuthEvalsSessionsRouteImport } from './routes/_auth/evals.sessions'
import { Route as AuthLearnIndexRouteImport } from './routes/_auth/learn.index'
import { Route as AuthReviewsIndexRouteImport } from './routes/_auth/reviews.index'
import { Route as AuthReviewsRoomIdRouteImport } from './routes/_auth/reviews.$roomId'
import { Route as AuthSessionGroupsIndexRouteImport } from './routes/_auth/session-groups.index'
import { Route as AuthSessionGroupsIdRouteImport } from './routes/_auth/session-groups.$id'
import { Route as AuthSessionsIndexRouteImport } from './routes/_auth/sessions.index'
import { Route as AuthSessionsIdRouteImport } from './routes/_auth/sessions.$id'
import { Route as ApplyPublicIdIndexRouteImport } from './routes/apply.$publicId.index'
import { Route as ApplyPublicIdCallSuccessRouteImport } from './routes/apply.$publicId.call-success'
import { Route as ApplyPublicIdInstantRouteImport } from './routes/apply.$publicId.instant'
import { Route as ApplyPublicIdScheduleRouteImport } from './routes/apply.$publicId.schedule'
import { Route as MeetingRoomPublicIdIndexRouteImport } from './routes/meeting.$roomPublicId.index'
import { Route as AuthEvalsEvaluatorsIndexRouteImport } from './routes/_auth/evals.evaluators.index'
import { Route as AuthEvalsEvaluatorsEvaluatorIdRouteImport } from './routes/_auth/evals.evaluators.$evaluatorId'
import { Route as AuthEvalsExperimentsIndexRouteImport } from './routes/_auth/evals.experiments.index'
import { Route as AuthEvalsExperimentsExperimentIdRouteImport } from './routes/_auth/evals.experiments.$experimentId'
import { Route as AuthEvalsReplaysIndexRouteImport } from './routes/_auth/evals.replays.index'
import { Route as AuthEvalsReplaysReplayIdRouteImport } from './routes/_auth/evals.replays.$replayId'
import { Route as AuthEvalsRunsIndexRouteImport } from './routes/_auth/evals.runs.index'
import { Route as AuthLearnPathIdRouteImport } from './routes/_auth/learn.path.$id'
import { Route as AuthReviewsGenerationsRunIdRouteImport } from './routes/_auth/reviews.generations.$runId'
import { Route as AuthEvalsRunsRunIdLiveRouteImport } from './routes/_auth/evals.runs.$runId.live'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const AuthActionRoute = AuthActionRouteImport.update({
            id: '/auth-action',path: '/auth-action',getParentRoute: () => rootRouteImport
          })
const CsaeRoute = CsaeRouteImport.update({
            id: '/csae',path: '/csae',getParentRoute: () => rootRouteImport
          })
const ExtensionAuthRoute = ExtensionAuthRouteImport.update({
            id: '/extension-auth',path: '/extension-auth',getParentRoute: () => rootRouteImport
          })
const ExtensionSignedInRoute = ExtensionSignedInRouteImport.update({
            id: '/extension-signed-in',path: '/extension-signed-in',getParentRoute: () => rootRouteImport
          })
const LinkedinAdRoute = LinkedinAdRouteImport.update({
            id: '/linkedin-ad',path: '/linkedin-ad',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PracticeRoute = PracticeRouteImport.update({
            id: '/practice',path: '/practice',getParentRoute: () => rootRouteImport
          })
const RecordingViewRoute = RecordingViewRouteImport.update({
            id: '/recording-view',path: '/recording-view',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const AuthAccountRoute = AuthAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthRoute
          })
const AuthAiRoute = AuthAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => AuthRoute
          })
const AuthBillingRoute = AuthBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthRoute
          })
const AuthChatRoute = AuthChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthRoute
          })
const AuthDashboardRoute = AuthDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthRoute
          })
const AuthExploreRoute = AuthExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => AuthRoute
          })
const AuthFeedbackRoute = AuthFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => AuthRoute
          })
const AuthHelpRoute = AuthHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => AuthRoute
          })
const AuthLeadsRoute = AuthLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthRoute
          })
const AuthMembersRoute = AuthMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthRoute
          })
const DevAdvancedBlocksPreviewRoute = DevAdvancedBlocksPreviewRouteImport.update({
            id: '/dev/advanced-blocks-preview',path: '/dev/advanced-blocks-preview',getParentRoute: () => rootRouteImport
          })
const DevBoardPreviewRoute = DevBoardPreviewRouteImport.update({
            id: '/dev/board-preview',path: '/dev/board-preview',getParentRoute: () => rootRouteImport
          })
const DevInteractivePreviewRoute = DevInteractivePreviewRouteImport.update({
            id: '/dev/interactive-preview',path: '/dev/interactive-preview',getParentRoute: () => rootRouteImport
          })
const LearnPublicIdRoute = LearnPublicIdRouteImport.update({
            id: '/learn/$publicId',path: '/learn/$publicId',getParentRoute: () => rootRouteImport
          })
const SummarySessionTemplateIdRoute = SummarySessionTemplateIdRouteImport.update({
            id: '/summary/$sessionTemplateId',path: '/summary/$sessionTemplateId',getParentRoute: () => rootRouteImport
          })
const AuthApplicationsSessionIdRoute = AuthApplicationsSessionIdRouteImport.update({
            id: '/applications/$sessionId',path: '/applications/$sessionId',getParentRoute: () => AuthRoute
          })
const AuthDevGenerationRoute = AuthDevGenerationRouteImport.update({
            id: '/dev/generation',path: '/dev/generation',getParentRoute: () => AuthRoute
          })
const AuthEvalsIndexRoute = AuthEvalsIndexRouteImport.update({
            id: '/evals/',path: '/evals/',getParentRoute: () => AuthRoute
          })
const AuthEvalsLabelRoute = AuthEvalsLabelRouteImport.update({
            id: '/evals/label',path: '/evals/label',getParentRoute: () => AuthRoute
          })
const AuthEvalsLabelingRoute = AuthEvalsLabelingRouteImport.update({
            id: '/evals/labeling',path: '/evals/labeling',getParentRoute: () => AuthRoute
          })
const AuthEvalsSessionsRoute = AuthEvalsSessionsRouteImport.update({
            id: '/evals/sessions',path: '/evals/sessions',getParentRoute: () => AuthRoute
          })
const AuthLearnIndexRoute = AuthLearnIndexRouteImport.update({
            id: '/learn/',path: '/learn/',getParentRoute: () => AuthRoute
          })
const AuthReviewsIndexRoute = AuthReviewsIndexRouteImport.update({
            id: '/reviews/',path: '/reviews/',getParentRoute: () => AuthRoute
          })
const AuthReviewsRoomIdRoute = AuthReviewsRoomIdRouteImport.update({
            id: '/reviews/$roomId',path: '/reviews/$roomId',getParentRoute: () => AuthRoute
          })
const AuthSessionGroupsIndexRoute = AuthSessionGroupsIndexRouteImport.update({
            id: '/session-groups/',path: '/session-groups/',getParentRoute: () => AuthRoute
          })
const AuthSessionGroupsIdRoute = AuthSessionGroupsIdRouteImport.update({
            id: '/session-groups/$id',path: '/session-groups/$id',getParentRoute: () => AuthRoute
          })
const AuthSessionsIndexRoute = AuthSessionsIndexRouteImport.update({
            id: '/sessions/',path: '/sessions/',getParentRoute: () => AuthRoute
          })
const AuthSessionsIdRoute = AuthSessionsIdRouteImport.update({
            id: '/sessions/$id',path: '/sessions/$id',getParentRoute: () => AuthRoute
          })
const ApplyPublicIdIndexRoute = ApplyPublicIdIndexRouteImport.update({
            id: '/apply/$publicId/',path: '/apply/$publicId/',getParentRoute: () => rootRouteImport
          })
const ApplyPublicIdCallSuccessRoute = ApplyPublicIdCallSuccessRouteImport.update({
            id: '/apply/$publicId/call-success',path: '/apply/$publicId/call-success',getParentRoute: () => rootRouteImport
          })
const ApplyPublicIdInstantRoute = ApplyPublicIdInstantRouteImport.update({
            id: '/apply/$publicId/instant',path: '/apply/$publicId/instant',getParentRoute: () => rootRouteImport
          })
const ApplyPublicIdScheduleRoute = ApplyPublicIdScheduleRouteImport.update({
            id: '/apply/$publicId/schedule',path: '/apply/$publicId/schedule',getParentRoute: () => rootRouteImport
          })
const MeetingRoomPublicIdIndexRoute = MeetingRoomPublicIdIndexRouteImport.update({
            id: '/meeting/$roomPublicId/',path: '/meeting/$roomPublicId/',getParentRoute: () => rootRouteImport
          })
const AuthEvalsEvaluatorsIndexRoute = AuthEvalsEvaluatorsIndexRouteImport.update({
            id: '/evals/evaluators/',path: '/evals/evaluators/',getParentRoute: () => AuthRoute
          })
const AuthEvalsEvaluatorsEvaluatorIdRoute = AuthEvalsEvaluatorsEvaluatorIdRouteImport.update({
            id: '/evals/evaluators/$evaluatorId',path: '/evals/evaluators/$evaluatorId',getParentRoute: () => AuthRoute
          })
const AuthEvalsExperimentsIndexRoute = AuthEvalsExperimentsIndexRouteImport.update({
            id: '/evals/experiments/',path: '/evals/experiments/',getParentRoute: () => AuthRoute
          })
const AuthEvalsExperimentsExperimentIdRoute = AuthEvalsExperimentsExperimentIdRouteImport.update({
            id: '/evals/experiments/$experimentId',path: '/evals/experiments/$experimentId',getParentRoute: () => AuthRoute
          })
const AuthEvalsReplaysIndexRoute = AuthEvalsReplaysIndexRouteImport.update({
            id: '/evals/replays/',path: '/evals/replays/',getParentRoute: () => AuthRoute
          })
const AuthEvalsReplaysReplayIdRoute = AuthEvalsReplaysReplayIdRouteImport.update({
            id: '/evals/replays/$replayId',path: '/evals/replays/$replayId',getParentRoute: () => AuthRoute
          })
const AuthEvalsRunsIndexRoute = AuthEvalsRunsIndexRouteImport.update({
            id: '/evals/runs/',path: '/evals/runs/',getParentRoute: () => AuthRoute
          })
const AuthLearnPathIdRoute = AuthLearnPathIdRouteImport.update({
            id: '/learn/path/$id',path: '/learn/path/$id',getParentRoute: () => AuthRoute
          })
const AuthReviewsGenerationsRunIdRoute = AuthReviewsGenerationsRunIdRouteImport.update({
            id: '/reviews/generations/$runId',path: '/reviews/generations/$runId',getParentRoute: () => AuthRoute
          })
const AuthEvalsRunsRunIdLiveRoute = AuthEvalsRunsRunIdLiveRouteImport.update({
            id: '/evals/runs/$runId/live',path: '/evals/runs/$runId/live',getParentRoute: () => AuthRoute
          })





const AuthRouteChildren = {
  AuthAccountRoute: AuthAccountRoute,AuthAiRoute: AuthAiRoute,AuthBillingRoute: AuthBillingRoute,AuthChatRoute: AuthChatRoute,AuthDashboardRoute: AuthDashboardRoute,AuthExploreRoute: AuthExploreRoute,AuthFeedbackRoute: AuthFeedbackRoute,AuthHelpRoute: AuthHelpRoute,AuthLeadsRoute: AuthLeadsRoute,AuthMembersRoute: AuthMembersRoute,AuthApplicationsSessionIdRoute: AuthApplicationsSessionIdRoute,AuthDevGenerationRoute: AuthDevGenerationRoute,AuthEvalsLabelRoute: AuthEvalsLabelRoute,AuthEvalsLabelingRoute: AuthEvalsLabelingRoute,AuthEvalsSessionsRoute: AuthEvalsSessionsRoute,AuthReviewsRoomIdRoute: AuthReviewsRoomIdRoute,AuthSessionGroupsIdRoute: AuthSessionGroupsIdRoute,AuthSessionsIdRoute: AuthSessionsIdRoute,AuthEvalsIndexRoute: AuthEvalsIndexRoute,AuthLearnIndexRoute: AuthLearnIndexRoute,AuthReviewsIndexRoute: AuthReviewsIndexRoute,AuthSessionGroupsIndexRoute: AuthSessionGroupsIndexRoute,AuthSessionsIndexRoute: AuthSessionsIndexRoute,AuthEvalsEvaluatorsEvaluatorIdRoute: AuthEvalsEvaluatorsEvaluatorIdRoute,AuthEvalsExperimentsExperimentIdRoute: AuthEvalsExperimentsExperimentIdRoute,AuthEvalsReplaysReplayIdRoute: AuthEvalsReplaysReplayIdRoute,AuthLearnPathIdRoute: AuthLearnPathIdRoute,AuthReviewsGenerationsRunIdRoute: AuthReviewsGenerationsRunIdRoute,AuthEvalsEvaluatorsIndexRoute: AuthEvalsEvaluatorsIndexRoute,AuthEvalsExperimentsIndexRoute: AuthEvalsExperimentsIndexRoute,AuthEvalsReplaysIndexRoute: AuthEvalsReplaysIndexRoute,AuthEvalsRunsIndexRoute: AuthEvalsRunsIndexRoute,AuthEvalsRunsRunIdLiveRoute: AuthEvalsRunsRunIdLiveRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRouteWithChildren,AuthActionRoute: AuthActionRoute,CsaeRoute: CsaeRoute,ExtensionAuthRoute: ExtensionAuthRoute,ExtensionSignedInRoute: ExtensionSignedInRoute,LinkedinAdRoute: LinkedinAdRoute,LoginRoute: LoginRoute,PracticeRoute: PracticeRoute,RecordingViewRoute: RecordingViewRoute,RegisterRoute: RegisterRoute,VerifyEmailRoute: VerifyEmailRoute,DevAdvancedBlocksPreviewRoute: DevAdvancedBlocksPreviewRoute,DevBoardPreviewRoute: DevBoardPreviewRoute,DevInteractivePreviewRoute: DevInteractivePreviewRoute,LearnPublicIdRoute: LearnPublicIdRoute,SummarySessionTemplateIdRoute: SummarySessionTemplateIdRoute,ApplyPublicIdCallSuccessRoute: ApplyPublicIdCallSuccessRoute,ApplyPublicIdInstantRoute: ApplyPublicIdInstantRoute,ApplyPublicIdScheduleRoute: ApplyPublicIdScheduleRoute,ApplyPublicIdIndexRoute: ApplyPublicIdIndexRoute,MeetingRoomPublicIdIndexRoute: MeetingRoomPublicIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)